import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-box-wrapper',
  standalone: true,
  imports: [CommonModule],
  styleUrls: ['./box-wrapper.component.scss'],
  template: `@if (!hasError) {
    <div class="wrapper">
      <p class="font-bold text-lg py-2 m-0">{{ title }}</p>
      <ng-content></ng-content>
    </div>
    } @else {
    <div class="wrapper pt-2">
      <p><strong>Kunne ikke hente data</strong></p>
      <p>Om problemet vedvarer, kontakt kundeservice.</p>
    </div>
    }`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BoxWrapperComponent {
  @Input() hasError: boolean;
  @Input() title: string | undefined;
}
